import * as Styles from './styles';
import HistoryContent from './HistoryContent';
import styled from "styled-components";
import { CustomScrollbarWrapper } from 'cdk-radial';

const StyledCustomScrollbarWrapper = styled(CustomScrollbarWrapper)`
  height: calc(100% - 50px);
  overflow-x: hidden;
`;

export default function HistoryContainer() {
  return (
    <Styles.HistoryContent>
      <StyledCustomScrollbarWrapper>
        <HistoryContent />
      </StyledCustomScrollbarWrapper>
    </Styles.HistoryContent>
  );
};
